spec_version: '1.1'
id: 5
slug: 05-inversion-largo-plazo
titulo: Inversión a largo plazo
duracion_min: 135
estado: placeholder
fase_produccion: 0
ultima_actualizacion: '2026-06-15'
prerrequisitos: []
objetivos_aprendizaje:
- id: OA-05.1
  texto: Entender qué es un fondo indexado y por qué es el vehículo recomendado para
    el inversor principiante
  bloom: ''
- id: OA-05.2
  texto: Definir tu cartera según perfil de riesgo y horizonte
  bloom: ''
- id: OA-05.3
  texto: Configurar aportaciones periódicas y disciplina operativa
  bloom: ''
glosario: []
secciones:
- tipo: teoria
  archivo: teoria.md
- tipo: quiz-practica
  archivo: quiz-practica.md
- tipo: recursos
  archivo: recursos.md
sub_secciones_teoria:
- id: '5.1'
  titulo: 'Inflación: el coste real de no invertir'
  duracion_min: 15
- id: '5.2'
  titulo: Perfil de riesgo y horizonte temporal
  duracion_min: 20
- id: '5.3'
  titulo: 'Fondos indexados: qué son y por qué funcionan'
  duracion_min: 25
- id: '5.4'
  titulo: 'DCA: aportación periódica frente al timing'
  duracion_min: 20
- id: '5.5'
  titulo: Diversificación geográfica y por clase de activo
  duracion_min: 20
- id: '5.6'
  titulo: Brokers, comisiones y operativa práctica
  duracion_min: 20
- id: '5.7'
  titulo: Errores típicos del inversor principiante
  duracion_min: 15
